var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-avatar',{staticStyle:{"height":"60px","width":"60px","-o-object-fit":"cover","object-fit":"cover","margin-right":"15px"},attrs:{"text":_vm.fullname.toUpperCase()}})
}
var staticRenderFns = []

export { render, staticRenderFns }